@if (title) {
  <p class="c__title is-caption is-bold">
    {{title}} ({{devices.length}})
  </p>
}
<ul sd-list-inline class="c__devices-container is-xs">
  @for (device of devices | slice: 0:maxProductDisplayed; track device) {
    <li>
      <sd-device
        [device]="device"
        [isSmall]="isSmall"
        [brand]="brand"
        [isHovered]="isHovered"
        (deviceIsClicked)="onDeviceClicked(device)"
      />
    </li>
  }
  <li>
    @if (devices.length > maxProductDisplayed) {
      <sd-push-card
        [brand]="brand"
        [indexFollow]="push?.indexFollow !== undefined ? push?.indexFollow : true"
        [pushSize]="pushSizeEnum.xs"
        [push]="push.push"
        [textConfig]="positionEnum.center"
        [mediaAsBackground]="true"
        [themesConfig]="push?.themesConfig"
        [isDescription]="true"
        [hasReadMore]="false" (clicked)="onDevicePushClicked($event)"
      />
    }
  </li>
</ul>
